import { z } from 'zod';
import type { EntitlementRule } from '@/api/auth/missionImpactAuthAPI.schemas';

/**
 * Schema for creating a product trial. The rule is the generated polymorphic EntitlementRule
 * (built by the rule editor); we validate the surrounding form fields here.
 */
export const createProductTrialSchema = z.object({
  rule: z.custom<EntitlementRule>(),
  durationDays: z
    .number()
    .int()
    .positive('Duration must be a positive number')
    .nullish(),
});

/**
 * TypeScript type inferred from schema
 */
export type CreateProductTrial = z.infer<typeof createProductTrialSchema>;
